import React from 'react'
import RoundIcon from '../RoundIcon/RoundIcon'
import iconsMap from '../../../assets/data/iconsMaps'

const SelectorGridItem = (props) => {
  const { atom, onAtomSelect, selected, img, disabled } = props;
  let classes = "selector-grid-item"
  if (disabled) classes += " disabled";
  return (
    <div className={classes}>
      <div className="secetor-grid-item-content">
        <div className="selector-grid-item-icon">
          <RoundIcon img={img} selected={selected} action={() => onAtomSelect()} />
        </div>
        <div className="selector-grid-item-alias">
          {atom.alias}
        </div>
        <div className="selector-grid-item-name">
          {atom.name}
        </div>
      </div>
    </div>
  )
}

export default SelectorGridItem